import { CompetitionResultTable } from './components/competition-result-table';
import { CompetitionTeamResultPage } from './team/page';
import { OptionTuple } from '~/components/Input/SearchSelect/SearchSelect';
import { PageLayout } from '~/components/PageLayout/PageLayout';
import { useCompetitionQuery } from '../queries';
import { useParams } from '~/hooks/useParams';
import { Grid } from '~/components/Grid/Grid';
import { Fragment } from 'react/jsx-runtime';
import { Input } from '~/components/Input';
import { idParamSchema } from '~/schemas';
import { useMemo, useState } from 'react';
import { Menu } from '../detail/menu';
import { Panel } from '~/components/Panel/Panel';
import { Link } from '~/components/Link/Link';
import { Button } from '~/components/Button/Button';
import { CompetitionTypeNameEnum } from '~/apis/ssf';

// TODO: remove me later
export function Page() {
  const { id } = useParams(idParamSchema.parse);
  const { data, isLoading } = useCompetitionQuery(id);

  const [competitionType, setCompetitionType] = useState<string>();
  const [ageCategory, setAgeCategory] = useState<string>();
  const [gender, setGender] = useState<string>();

  const results = useMemo(() => data?.results ?? [], [data]);

  const headingSubText = useMemo<string | undefined>(() => {
    if (!data) return undefined;
    const date =
      data.start_date && data.end_date && data.start_date !== data.end_date
        ? `${data.start_date} - ${data.end_date}`
        : (data.start_date ?? data.end_date ?? '');
    const parts = [date, data.location].filter(Boolean);
    return parts.length > 0 ? parts.join(', ') : undefined;
  }, [data]);

  const competitionTypeOptions = useMemo<OptionTuple[]>(() => {
    return results.map(r => [r.label, r.name]);
  }, [results]);

  const ageCategoriesOptions = useMemo<OptionTuple[]>(() => {
    return results
      .filter(r => {
        if (!competitionType) return true;
        return competitionType === r.name;
      })
      .flatMap(r => r.age_categories.map(a => [a.label, a.name] as OptionTuple))
      .filter((item, index, self) => index === self.findIndex(t => t[0] === item[0] && t[1] === item[1]));
  }, [competitionType, results]);

  const genderOptions: OptionTuple[] = [
    ['Herr', 'men'],
    ['Dam', 'women'],
  ];

  if (data?.is_team_comp) {
    return (
      <Fragment>
        <PageLayout.Header>
          <PageLayout.Heading text={data.name} />

          <Button.Group neutral>
            <Link to={`/competitions/${id}`}>
              <Button type="button">Visa tävlingsinformation</Button>
            </Link>

            <Menu isResultsPage />
          </Button.Group>
        </PageLayout.Header>

        <CompetitionTeamResultPage competitionId={id} />
      </Fragment>
    );
  }

  return (
    <Fragment>
      <PageLayout.Header>
        <PageLayout.Heading text={data?.name ?? ''} subText={headingSubText} />

        <Button.Group neutral>
          <Link to={`/competitions/${id}`}>
            <Button type="button">Visa tävlingsinformation</Button>
          </Link>

          <Menu isResultsPage />
        </Button.Group>
      </PageLayout.Header>

      <Grid style={{ marginTop: 'var(--size-4)', marginBottom: 'var(--size-4)' }}>
        {competitionTypeOptions.length > 1 && (
          <Grid.Item cols={{ sm: 6, md: 4, lg: 3 }}>
            <Input.Select
              placeholder={'Alla tävlingstyper'}
              options={competitionTypeOptions}
              onChange={selected => setCompetitionType(selected.target.value)}
            />
          </Grid.Item>
        )}
        <Grid.Item cols={{ sm: 6, md: 4, lg: 3 }}>
          <Input.Select
            placeholder="Alla kategorier"
            options={ageCategoriesOptions}
            onChange={selected => setAgeCategory(selected.target.value)}
          />
        </Grid.Item>
        <Grid.Item cols={{ sm: 6, md: 4, lg: 3 }}>
          <Input.Select
            placeholder="Dam och herr"
            options={genderOptions}
            onChange={selected => setGender(selected.target.value)}
          />
        </Grid.Item>
      </Grid>

      {results.length === 0 && (
        <Panel variant="informative" size="sm">
          <p>Inga resultat hittades</p>
        </Panel>
      )}

      {results
        .filter(r => {
          if (!competitionType) return true;
          return competitionType === r.name;
        })
        .map(r => {
          return r.age_categories
            .filter(a => {
              if (!ageCategory) return true;
              return ageCategory === a.name;
            })
            .map(a =>
              a.weight_classes
                .filter(w => {
                  if (!gender) return true;
                  if (gender === 'men') return w.is_male;
                  if (gender === 'women') return !w.is_male;
                })
                .sort((a, b) => (b.is_male === a.is_male ? 0 : b.is_male ? -1 : 1))
                .map(w => {
                  return (
                    <PageLayout.Section key={w.id}>
                      <CompetitionResultTable
                        category={a.label}
                        weight={`${w.is_male ? 'Herr' : 'Dam'} ${w.name}`}
                        results={w.results}
                        isLoading={isLoading}
                        competitionTypeLabel={r.label}
                        competitionTypeName={r.name as CompetitionTypeNameEnum}
                        pointSystem={a.points_system}
                      />
                    </PageLayout.Section>
                  );
                })
            );
        })}
    </Fragment>
  );
}
